export const THREE_DAYS_IN_SECONDS = 259200
export const FIVE_MINUTES_IN_SECONDS = 300
export const ONE_HOUR_IN_SECONDS = 3600
export const ONE_DAY_IN_SECONDS = 86400
export const ONE_MONTH_IN_SECONDS = 2592000
export const ONE_YEAR_IN_SECONDS = 31536000
